module.exports = __webpack_public_path__ + "img/icon8.53e66c79.png";